import { Injectable } from '@angular/core';
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { map } from 'rxjs/operators';
import { from, Observable } from 'rxjs';
import { AccountService } from './account.service';
import {UserRole} from '../models/user/user-role';
import { UserService } from './user.service';

@Injectable()
export class YourPlaceUserAuthGuard {

    constructor(private accountService: AccountService, private _router: Router, private userService: UserService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
        return this.checkIsYourPlaceUser(state);
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
        return this.checkIsYourPlaceUser(state);
    }

    private checkIsYourPlaceUser(state: RouterStateSnapshot): boolean | Observable<boolean> {
        const isLoggedIn = this.accountService.isLoggedIn();
        if (!isLoggedIn) {
            return from(this._router.navigate(['/login'], { queryParams: { redirect_to: state.url } }))
                .pipe(map(() => false));
        }

        const user = this.accountService.getCurrentUser();
        const hasRole = this.accountService.accessTokenHasRole(UserRole.YOUR_PLACE_STAFF)
        if(user && hasRole){
            return true;
        }

        this.userService.navigateToHomePage(user);
        return false;
    }
}
